var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section is-paddless",attrs:{"id":"app"}},[_c('div',{staticClass:"columns is-gapless"},[_c('div',{staticClass:"container vp-main-canvas"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }